type SignContent = {
  name: string;
  testId: string;
};

export enum ISignType {
  videoRecording = 'videoRecording',
  selfie = 'selfie',
}

export const SignList: { [key in ISignType]: SignContent } = {
  [ISignType.videoRecording]: {
    name: 'Document and face',
    testId: 'settings_signature_video_face_document_option',
  },
  [ISignType.selfie]: {
    name: 'Face',
    testId: 'settings_signature_face_option',
  },
};
